<template>
    <div class="card shadow-none border-0">
        <div class="card-header pb-0">
            <div class="row align-top">
                <div class="col-md-2">
                    <h6>Clientes</h6>
                </div>
                <div class="col-md-8">
                    <div class="input-group">
                        <span class="input-group-text text-body">
                            <i class="fas fa-search" aria-hidden="true"></i>
                        </span>
                        <input
                            type="text"
                            class="form-control"
                            :value="searchTerm"
                            @input="$emit('update:searchTerm', $event.target.value)"
                            placeholder="Buscar por Documento, Nombre o Contacto..."
                        />
                    </div>
                </div>
                <div class="col-md-2">
                    <argon-button
                        class="mt-0"
                        color="success"
                        fullWidth
                        size="xs"
                        @click="toCreate"
                    >
                        Agregar Nuevo
                    </argon-button>
                </div>
            </div>
        </div>

        <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                    <thead>
                        <tr>
                            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 ps-4">Nombre</th>
                            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 ps-2">Documento</th>
                            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 ps-2">Contacto</th>
                            <th class="text-uppercase text-xxs font-weight-bolder opacity-7">Sexo</th>
                            <th class="text-uppercase text-xxs font-weight-bolder opacity-7">Dirección</th>
                            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-center">Fecha Creación</th>
                            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-center">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="clients.length === 0">
                            <td colspan="7" class="text-center py-4 text-muted">
                                {{ searchTerm ? `No hay coincidencias con la búsqueda de "${searchTerm}".` : 'No se encontraron clientes.' }}
                            </td>
                        </tr>

                        <tr v-for="(client, index) in clients" :key="index">
                            <td>
                                <div class="d-flex px-2 py-1">
                                    <div class="d-flex flex-column justify-content-center">
                                        <h6 class="mb-0 text-sm">{{ client.name }}</h6>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0 ps-2">{{ client.document || 'N/A' }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">{{ client.email || 'Sin Correo' }}</p>
                                <p class="text-xs text-secondary mb-0">{{ client.phone || 'Sin Teléfono' }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">{{ getClientTypeText(client.gender) }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">
                                    {{ client.address ? (client.address.substring(0, 30) + (client.address.length > 30 ? '...' : '')) : 'Sin dirección' }}
                                </p>
                            </td>
                            <td class="text-center">
                                <p class="text-xs font-weight-bold mb-0">
                                    {{ $formatDate ? $formatDate(client.created_at) : client.created_at }}
                                </p>
                            </td>
                            <td class="align-middle text-center">
                                <a @click="openExpediente(client)" class="btn bg-info mx-1 shadow-none" title="Ver expediente">
                                    <i class="fa fa-folder-open text-white text-sm opacity-10"></i>
                                </a>
                                <a @click="toEdit(client.id)" class="btn bg-success mx-1 shadow-none" title="Editar cliente">
                                    <i class="fa fa-pen text-white text-sm opacity-10"></i>
                                </a>
                                <a @click="deleteClient(client.id, client.name)" class="btn bg-danger mx-1 shadow-none" title="Eliminar cliente">
                                    <i class="fa fa-trash text-white text-sm opacity-10"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import axios from "axios";
import Swal from 'sweetalert2';

const clientTypeMap = {
    'M': 'MASCULINO',
    'F': 'FEMENINO',
    'O': 'OTRO',
};

export default {
    name: "ClientsTable",
    components: { ArgonButton },
    props: {
        // Recibimos la lista ya filtrada y paginada por el Padre
        clients: {
            type: Array,
            required: true
        },
        // Recibimos el término de búsqueda para mostrar mensajes de "no encontrado"
        searchTerm: {
            type: String,
            default: ''
        }
    },
    methods: {
        getClientTypeText(clientCode) {
            return clientTypeMap[clientCode] || clientCode;
        },
        toCreate() {
            this.$router.push('/clients/create');
        },
        toEdit(clientId) {
            this.$router.push(`/clients/${clientId}`);
        },
        openExpediente(client) {
            this.$router.push({
                name: 'ClientExpediente',
                params: { id: client.id }
            });
        },
        deleteClient(clientId, clientName) {
            const token = localStorage.getItem("accessToken");
            const apiURL = this.$store.state.apiURL;
            const config = {
                headers: { 'Authorization': `Bearer ${token}` }
            };

            Swal.fire({
                title: `¿Eliminar cliente ${clientName}?`,
                text: 'Esta acción no se puede deshacer.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.delete(apiURL + 'clients/' + clientId, config)
                        .then(() => {
                            Swal.fire('Eliminado', 'Cliente borrado correctamente.', 'success');
                            this.$emit('client-deleted');
                        })
                        .catch((error) => {
                            console.error('Error:', error);
                            Swal.fire('Error', 'No se pudo eliminar el cliente.', 'error');
                        });
                }
            });
        }
    }
};
</script>

<style scoped>
.table th, .table td {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.pointer { cursor: pointer; }
</style>